import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "mpx-app-scope";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "mpx-app-scope" };
/** script content **/
require("./app.ts?ctorType=app&index=0&isApp&lang=ts&mpx&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fexample%2Fapp.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["mpx-app-scope"],
    ctorType: "app",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'mpx-keep-alive': getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-keep-alive.vue?isComponent"), { __mpxBuiltIn: true }) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
